
const ProjectExperienceSection = () => {
  const majorProjects = [
    {
      name: "Henry Hudson Parkway",
      client: "New York City DOT",
      type: "Highway Infrastructure"
    },
    {
      name: "Throgs Neck Bridge",
      client: "TBTA",
      type: "Bridge Construction"
    },
    {
      name: "Westside Highway",
      client: "New York City DOT",
      type: "Highway Infrastructure"
    },
    {
      name: "Merit Parkway",
      client: "Connecticut DOT",
      type: "Highway Infrastructure"
    },
    {
      name: "Boston Spray Gas Tanks",
      client: "Various",
      type: "Industrial Infrastructure"
    },
    {
      name: "Hudson Yards Vessel",
      client: "Various",
      type: "Commercial Development"
    },
    {
      name: "Cropsey Avenue",
      client: "New York City DOT",
      type: "Highway Infrastructure"
    },
    {
      name: "Staten Island Bridges",
      client: "New York City DOT",
      type: "Bridge Construction"
    },
    {
      name: "Pulaski Bridge",
      client: "New Jersey DOT",
      type: "Bridge Construction"
    },
    {
      name: "Goethals Bridge",
      client: "Port Authority",
      type: "Bridge Construction"
    }
  ];

  const clients = [
    "Ahern Painting",
    "Champion Specialty",
    "MLJ",
    "PJS",
    "Skanska"
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Project Experience & Clients</h2>
          <p className="text-lg text-gray-600">
            Proven track record on major infrastructure projects across the Northeast
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Major Projects */}
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Major Projects</h3>
            <div className="space-y-4">
              {majorProjects.map((project, index) => (
                <div key={index} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h4 className="font-semibold text-gray-800">{project.name}</h4>
                      <p className="text-sm text-blue-600">{project.client}</p>
                    </div>
                    <span className="text-xs bg-orange-100 text-orange-700 px-2 py-1 rounded-full whitespace-nowrap ml-2">
                      {project.type}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Clients & Certifications */}
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6">Trusted Clients</h3>
            <div className="bg-white rounded-lg p-6 shadow-sm mb-8">
              <div className="grid grid-cols-1 gap-4">
                {clients.map((client, index) => (
                  <div key={index} className="flex items-center p-3 bg-gray-50 rounded-lg">
                    <div className="w-8 h-8 flex items-center justify-center bg-blue-100 rounded-full mr-3">
                      <i className="ri-building-line text-blue-600"></i>
                    </div>
                    <span className="font-medium text-gray-800">{client}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-orange-50 rounded-lg p-6">
              <h4 className="text-xl font-bold text-orange-800 mb-4">Certified Expertise</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-medal-line text-orange-600 mr-3"></i>
                  <span className="text-gray-700">NACE Certified Inspectors Level 1-3</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-user-star-line text-orange-600 mr-3"></i>
                  <span className="text-gray-700">Industrial Hygienists Available</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-shield-check-line text-orange-600 mr-3"></i>
                  <span className="text-gray-700">OSHA Compliance Specialists</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-leaf-line text-orange-600 mr-3"></i>
                  <span className="text-gray-700">Environmental Consultants</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="bg-blue-600 text-white rounded-lg p-8">
            <h3 className="text-2xl font-bold mb-4">Ready to Start Your Project?</h3>
            <p className="text-lg mb-6">
              Contact HP Inc. today to discuss your safety consulting and environmental monitoring needs
            </p>
            <button className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap cursor-pointer">
              Get Started Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectExperienceSection;
